export default {
  create: {
    title: 'Add',
    subtitle: 'Games',
  },
  edit: {
    title: 'Edit',
    subtitle: 'Game',
    button: {
      add: 'New game',
    },
  },
  list: {
    title: 'Shape Links',
    subtitle: 'List',
    add: 'New game',
  },
  card: {
    title: 'Shape Link',
    actions: 'Actions',
  },
  table: {
    title: 'Active games',
    searchPlaceholder: 'Search...',
  },
  form: {
    name: {
      label: 'Name:',
      placeholder: 'E.g.: Shape Link Level 1',
      invalid: 'Name is required',
    },
    showAnswer: {
      label: 'Show answer',
    },
    colored: {
      label: 'Colored',
    },
    columns: {
      label: 'Columns:',
    },
    rows: {
      label: 'Rows:',
    },
    numPairs: {
      label: 'Number of pairs:',
      auto: 'Automatic',
      tooltipAuto: 'Ideal suggestion: {count} pairs for this grid.',
      tooltipManual: 'Set the number of pairs manually.',
    },
    filled: {
      label: 'Fill style:',
      auto: 'Automatic',
      filled: 'Solid',
      outline: 'Outline',
      tooltipWarning: "More than 9 pairs: Fill style locked to 'Automatic'",
      tooltipInfo:
        'In Automatic mode, the system alternates between solid and outline for better readability',
    },
    shapeMode: {
      label: 'Display mode:',
      geometric: 'Geometric shapes',
      number: 'Numbers',
    },
    pathWeight: {
      label: 'Line thickness:',
      thin: 'Thin',
      normal: 'Normal',
      bold: 'Thick',
    },
    numberStyle: {
      label: 'Number frame:',
      plain: 'Number only',
      circle: 'Circle',
      square: 'Square',
      rounded: 'Rounded',
    },
  },
  button: {
    generate: 'Generate game',
  },
  sidebar: {
    exportHint: 'You need to save before exporting.',
    defaultFileName: 'shapelinks',
  },
  alert: {
    generated: 'Puzzle generated successfully!',
    generateFailed:
      'Failed to generate the puzzle. Try increasing the number of pairs.',
    generateError: 'Generation error.',
    workerError: 'Internal worker error.',
    gameSaved: 'Game saved successfully!',
    workerErrors: {
      seedProductionFailed: 'Failed to produce seeds.',
      generationTimeout: 'Could not generate within the time limit.',
    },
  },
};
